module.exports = __webpack_public_path__ + "cd455783/img/comments-icon.fdec7fdb.svg";